import { DEFAULT_LAYOUT } from '../base';
import type { AppRouteRecordRaw } from '../types';

const CONFIGURATION: AppRouteRecordRaw = {
  path: '/configuration',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '通用配置',
    icon: 'icon-settings',
    order: 50
  },
  children: [
    {
      path: 'classification',
      component: () => {
        return import('@/views/configuration/classification/page.vue');
      },
      meta: {
        locale: '实体分类管理'
      }
    },
    {
      path: 'dimension',
      component: () => {
        return import('@/views/configuration/dimension/page.vue');
      },
      meta: {
        locale: '维度管理'
      }
    },
    {
      path: 'function',
      component: () => {
        return import('@/views/configuration/function/page.vue');
      },
      meta: {
        locale: '函数管理'
      }
    }
  ]
};

export default CONFIGURATION;
